<template>
  <div>
    <div class="google-map" id="google-map"></div>
    <div class="get-current" v-if="showCurrent">
      <a href="javascript:void(0)" class="current-button" @click="getCurrent()">get current</a>
    </div>
  </div>
</template>

<script>

/* eslint-disable handle-callback-err,no-new */
import utils from '../../../utils/vue/Utils'
import storage from '../../../utils/vue/LocalStorage'
export default {
  name: 'google-map',
  data () {
    return {
      map: null,
      tilesloaded: false,
      curZoom: null,
      latLngList: [],
      showCurrent: false
    }
  },
  created () {
    const urlParams = new URLSearchParams(window.location.search)
    const location = urlParams.get('location')
    if (location) {
      const latlng = location.split(',')
      if (latlng.length === 2) {
        var params = {lat: latlng[0], lng: latlng[1]}
        this.getUserApi('articles/findByLocation', params).then((res) => {
          const spot = res.data
          this.store.dispatch('detail/setId', parseInt(spot.id))
          this.store.dispatch('detail/setName', spot.name)
          this.store.dispatch('detail/setDescription', spot.description)
          this.store.dispatch('detail/setImageUrl', spot.image_url)
          this.store.dispatch('detail/setLat', spot.location_lat)
          this.store.dispatch('detail/setLng', spot.location_lon)
          this.store.dispatch('detail/setFromSns', true)
          this.showModal(this.constant.modal.detail)
          this.store.dispatch('menu/setForm', false)
          this.setMenuSelected()
        }).catch((error) => {
          console.error(error)
        })
      }
    }
    this.restoreSession()
  },
  mounted: function () {
    // ここでcreatedにするとdocument.getElementById('google-map')の読み込み箇所でエラー
    let options = {
      zoom: 16,
      center: new window.google.maps.LatLng(this.store.getters['centerLatLng/getLat'], this.store.getters['centerLatLng/getLng']),
      mapTypeControl: false,
      streetViewControl: false,
      scaleControl: false,
      panControl: false,
      fullscreenControl: false,
      clickableIcons: false,
      minZoom: 6
      // gestureHandling: 'cooperative'
    }
    this.map = new window.google.maps.Map(document.getElementById('google-map'), options)
    var _this = this
    this.map.addListener('tilesloaded', function () {
      if (_this.tilesloaded) return
      _this.tilesloaded = true
      console.log('~======>')
      _this.displayFirstMap()
      _this.setEvent(_this.map)
      setTimeout(() => {
        _this.showCurrent = true
      }, 500)
    })
  },
  methods: {
    getCurrent () {
      this.$emit('getCurrentPosition')
    },
    displayFirstMap () {
      let markerCoordinates = this.store.getters['coordinate/getCoordinate']
      if (this.store.getters['centerLatLng/getCurrent']) {
        new window.google.maps.Marker({
          position: new window.google.maps.LatLng(this.store.getters['centerLatLng/getLat'], this.store.getters['centerLatLng/getLng']),
          map: this.map,
          icon: '/static/icon_current_s.png'
        })
      }

      if (markerCoordinates.length === 0) {
        return
      }

      this.latLngList = []
      let distance = this.getMaxDistance(this.map.getZoom())
      markerCoordinates.forEach(coord => {
        this.latLngList.forEach(list => {
          console.log(parseFloat(list.lat))
          console.log(parseFloat(list.lng))
        })

        if (this.latLngList.some(list => (Math.abs(parseFloat(list.lat) - coord.location_lat) + Math.abs(parseFloat(list.lng) - coord.location_lon)) < distance)) return
        this.latLngList.push({lat: coord.location_lat, lng: coord.location_lon})

        let position = new window.google.maps.LatLng(coord.location_lat, coord.location_lon)
        // マーカーに合わせてズーム値を変更したい時のオプション
        // let bounds = new window.google.maps.LatLngBounds()
        // map.fitBounds(bounds.extend(position))

        this.displayMarker(this.map, position, coord, true)
      })
    },
    displayMap () {
      let markerCoordinates = this.store.getters['coordinate/getCoordinate']
      if (this.getItem('searching')) {
        this.clearAllMarkers()
      }

      if (markerCoordinates.length === 0) {
        this.clearAllMarkers()
        return
      }
      // Clear all old markers on map
      // this.markers.forEach(_ => _.setMap(null))
      let index = 0
      this.latLngList = []
      let distance = this.getMaxDistance(this.map.getZoom())
      let loop = setInterval(() => {
        let coord = markerCoordinates[index]

        if (this.latLngList.some(list => (Math.abs(parseFloat(list.lat) - coord.location_lat) + Math.abs(parseFloat(list.lng) - coord.location_lon)) < distance)) return
        this.latLngList.push({lat: coord.location_lat, lng: coord.location_lon})

        let position = new window.google.maps.LatLng(coord.location_lat, coord.location_lon)

        this.displayMarker(this.map, position, coord, false)
        index += 1
        if (index === markerCoordinates.length) {
          clearInterval(loop)
        }
      }, 0)

      setTimeout(() => {
        if (this.getItem('searching')) {
          var bounds = new window.google.maps.LatLngBounds()
          for (var i = 0; i < this.markers.length; i++) {
            bounds.extend(this.markers[i].getPosition())
          }
          console.log(bounds)
          this.map.fitBounds(bounds)
          this.setItem('searching', false)
        }
      }, 100)
    },
    displayMarker (map, position, coord, isFirst) {
      // let want = this.store.getters['want/getWant'] && this.store.getters['want/getWant'].some(want => want === parseInt(coord.id))
      // let went = this.store.getters['went/getWent'] && this.store.getters['went/getWent'].some(went => went === parseInt(coord.id))
      let favorite = this.store.getters['favorite/getFavorite'].some(favorite => favorite === parseInt(coord.id))
      // let pass = false
      // if (this.store.getters['search/getWant'] && want) {
      //   pass = true
      // }

      // if (this.store.getters['search/getWent'] && went) {
      //   pass = true
      // }

      // if (this.store.getters['search/getWant'] || this.store.getters['search/getWent']) {
      //   if (!pass) {
      //     return
      //   }
      // }
      const isShown = this.displayedSpots.some(s => s.id === coord['id'])
      const markerSize = parseInt(coord['marker_size']) || 50 // default to 50 pixel
      if (!isShown) {
        let markerProperty = {path: coord.thumb_url || coord.image_url, width: markerSize, height: markerSize, pointLeft: markerSize / 2, pointBottom: markerSize}
        let marker = this.setMarker(position, map, isFirst, markerProperty)
        this.markers.push(marker)
        this.displayedSpots.push(coord)
        let iconMarkerProperty = {path: '/static/icon_marker.png', width: 10, height: 10, pointLeft: 5, pointBottom: 1}
        let iconMarker = this.setMarker(position, map, isFirst, iconMarkerProperty)
        this.markers.push(iconMarker)
        this.setMarkerEvent(marker, coord)
      }

      if (favorite) {
        let wantMarkerProperty = {path: '/static/icon_want_marker.png', width: 24, height: 24, pointLeft: -markerSize / (1.41421 * 2) + 12, pointBottom: (1 + 1 / 1.41421) * (markerSize / 2) + 8}
        let wantMarker = this.setMarker(position, map, isFirst, wantMarkerProperty)
        this.markers.push(wantMarker)
        this.setMarkerEvent(wantMarker, coord)
      }
      // if (went && !want) {
      //   let wentMarkerProperty = {path: '/static/icon_went_marker.png', width: 24, height: 24, pointLeft: pointLeft[level], pointBottom: iconSize[level].height + 5}
      //   let wentMarker = this.setMarker(position, map, isFirst, wentMarkerProperty)
      //   this.markers.push(wentMarker)
      //   this.setMarkerEvent(wentMarker, coord)
      // }
    },
    setEvent (map) {
      let timer = 0
      let latLng = {}
      let newMarker = {}
      let centerLat = null
      let centerLng = null
      map.addListener('mousedown', (e) => {
        timer = 0
        setInterval(() => {
          timer += 1
        }, 600)

        latLng = e.latLng
        centerLat = map.getCenter().lat()
        centerLng = map.getCenter().lng()
      })

      map.addListener('mouseup', (e) => {
        // 座標の中心をずらす
        if (centerLat !== map.getCenter().lat() || centerLng !== map.getCenter().lng()) {
          this.store.dispatch('centerLatLng/setLat', map.getCenter().lat())
          this.store.dispatch('centerLatLng/setLng', map.getCenter().lng())
          this.getMarkerCoordinates()
          return
        }

        if (timer > 0) {
          // マーカーを設置
          if (Object.keys(newMarker).length > 0) {
            newMarker.setMap(null)
          }

          newMarker = new window.google.maps.Marker({
            position: latLng,
            map: map
          })

          // if (this.store.getters['user/getAccessToken']) {
          this.store.dispatch('menu/setForm', true)
          this.store.dispatch('saveLatLng/setLat', latLng.lat())
          this.store.dispatch('saveLatLng/setLng', latLng.lng())
          // } else {
          //   this.showModal(this.constant.modal.login)
          // }
        }
      })

      map.addListener('zoom_changed', () => {
        if (this.map.getZoom() !== this.curZoom) {
          this.curZoom = this.map.getZoom()
          this.store.dispatch('coordinate/setZoom', this.curZoom)
          this.getMarkerCoordinates()
        }
      })
    },
    setMarker (position, map, isFirst, property) {
      return new window.google.maps.Marker({
        position: position,
        map: map,
        // animation: isFirst ? window.google.maps.Animation.DROP : null,
        optimized: false,
        icon: {
          url: property.path,
          scaledSize: new window.google.maps.Size(property.width, property.height),
          origin: new window.google.maps.Point(0, 0),
          anchor: new window.google.maps.Point(property.pointLeft, property.pointBottom)
        }
      })
    },
    clearAllMarkers () {
      this.displayedSpots = []
      while (this.markers.length) {
        this.markers.pop().setMap(null)
      }
    },
    setMarkerEvent (marker, coord) {
      marker.addListener('click', () => {
        this.showModal(this.constant.modal.detail)
        this.store.dispatch('detail/setId', parseInt(coord.id))
        this.store.dispatch('detail/setName', coord.name)
        this.store.dispatch('detail/setDescription', coord.description)
        this.store.dispatch('detail/setImageUrl', coord.image_url)
        this.store.dispatch('detail/setLat', coord.location_lat)
        this.store.dispatch('detail/setLng', coord.location_lon)
        this.store.dispatch('menu/setForm', false)
        this.setMenuSelected()
      })
    },
    getMaxDistance (zoom) {
      // if (zoom === 6) {
      //   return 0.01
      // }
      // if (zoom === 7) {
      //   return 0.01
      // }
      // if (zoom === 8) {
      //   return 0.01
      // }
      // if (zoom === 9) {
      //   return 0.01
      // }
      // if (zoom === 10) {
      //   return 0.01
      // }
      // if (zoom === 11) {
      //   return 0.01
      // }
      // if (zoom === 12) {
      //   return 0.01
      // }
      // if (zoom === 13) {
      //   return 0.01
      // }
      // if (zoom === 14) {
      //   return 0.01
      // }
      // if (zoom === 15) {
      //   return 0.01
      // }
      // if (zoom === 16) {
      //   return 0.00150
      // }
      return 0
    },
    restoreSession () {
      this.store.dispatch('user/setUserID', this.getItem('user_id'))
      this.store.dispatch('user/setUserName', this.getItem('user_name'))
      this.store.dispatch('user/setAvatar', this.getItem('user_avatar'))
      this.store.dispatch('user/setAccessToken', this.getItem('access_token'))
      this.store.dispatch('user/setFbAccessToken', this.getItem('fb_access_token'))
    }
  },
  computed: {
    coordinate: function () {
      return this.store.getters['coordinate/getCoordinate']
    },
    zoomLatLng: function () {
      return {lat: this.$store.getters['zoomLatLng/getLat'], lng: this.$store.getters['zoomLatLng/getLng']}
    }
  },
  watch: {
    coordinate () {
      this.$nextTick(() => {
        if (!this.tilesloaded) return
        this.displayMap()
      })
    },
    zoomLatLng () {
      this.$nextTick(() => {
        let loc = new window.google.maps.LatLng(this.zoomLatLng.lat, this.zoomLatLng.lng)
        this.map.setCenter(loc)
        this.getMarkerCoordinates()
      })
    }
  },
  mixins: [utils, storage]
}
</script>

<style lang="scss" scoped src="../scss/GoogleMap.scss"></style>



// WEBPACK FOOTER //
// src/components/map/vue/GoogleMap.vue